import React from "react";
import { useTranslation } from "../../i18n";
import DateRangePicker from "./DateRangePicker";
import SEO from "../SEO";

export default function Hero({ dateRange, setDateRange }) {
  const { t } = useTranslation();

  return (
    <>
      <SEO 
        title={`${t("hero.titlePart1")} ${t("hero.titlePart2")}`}
        description={t("hero.description")}
        lang="fr"
      />
      
      <section className="relative h-[600px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1600&h=640&fit=crop"
            alt="Paysage du Jura"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40"></div>
        </div>

        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 drop-shadow-lg">
            {t("hero.titlePart1")} <br />
            <span className="text-emerald-400">{t("hero.titlePart2")}</span>
          </h1>

          <p className="text-xl md:text-2xl mb-8 max-w-2xl mx-auto drop-shadow-md">
            {t("hero.description")}
          </p>

          <div className="flex flex-wrap justify-center gap-4 items-center">
            <div className="inline-block">
              <DateRangePicker value={dateRange} onChange={setDateRange} />
            </div>

            <a
              href={`tel:${t("hero.phone")}`}
              className="rounded-lg bg-white/10 backdrop-blur border-2 border-white/30 px-8 py-4 text-lg font-semibold text-white hover:bg-white/20 transition shadow-xl"
            >
              📞 {t("hero.phone")}
            </a>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
          <svg
            className="w-6 h-6 text-white/60"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </div>
      </section>
    </>
  );
}